'use client';

import { useEffect } from 'react';

// const appId = YOUR_TOKEN;

const useIntercomScript = ({ appId }: { appId: string }) => {
  useEffect(() => {
    if (!appId) return;

    let d = document;
    let i: any = function () {
      i.c(arguments);
    };
    i.q = [];
    i.c = function (args: any) {
      i.q.push(args);
    };
    window.intercomSettings = {
      app_id: appId,
      alignment: 'right',
      horizontal_padding: 16,
    };
    window.Intercom = i;
    let l = function () {
      let _a, _b;
      let s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = `https://widget.intercom.io/widget/${(_a = window.intercomSettings) === null || _a === void 0 ? void 0 : _a.app_id}`;
      let x = d.getElementsByTagName('script')[0];
      (_b = x.parentNode) === null || _b === void 0 ? void 0 : _b.insertBefore(s, x);
    };
    if (document.readyState === 'complete') {
      l();
    } else if (window.attachEvent) {
      window.attachEvent('onload', l);
    } else {
      window.addEventListener('load', l, false);
    }
  }, [appId]);

  return null;
};

export default useIntercomScript;
